// src/components/layout/Sidebar.tsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  Package,
  ShoppingBag,
  Truck,
  BarChart3,
  Users,
  Settings,
} from 'lucide-react';

const Sidebar: React.FC = () => {
  const { hasRole } = useAuth();

  const adminLinks = [
    { to: '/dashboard', icon: BarChart3, label: 'Dashboard', roles: ['admin', 'manager'] },
    { to: '/orders', icon: ShoppingBag, label: 'Orders', roles: ['admin', 'manager', 'driver'] },
    { to: '/products', icon: Package, label: 'Inventory', roles: ['admin', 'manager'] },
    { to: '/drivers', icon: Truck, label: 'Drivers', roles: ['admin', 'manager'] },
    { to: '/users', icon: Users, label: 'Users', roles: ['admin'] },
    { to: '/settings', icon: Settings, label: 'Settings', roles: ['admin'] },
  ];

  const driverLinks = [
    { to: '/driver', icon: Truck, label: 'My Deliveries', roles: ['driver'] },
    { to: '/driver/cash', icon: BarChart3, label: 'Cash Summary', roles: ['driver'] },
  ];

  const links = [...adminLinks, ...driverLinks].filter(link =>
    link.roles.some(role => hasRole(role))
  );

  return (
    <div className="hidden md:flex md:flex-shrink-0">
      <div className="flex flex-col w-64 border-r bg-white">
        <div className="flex flex-col flex-1 pt-5 pb-4 overflow-y-auto">
          <nav className="flex-1 px-4 space-y-1">
            {links.map((link) => {
              const Icon = link.icon;
              return (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) =>
                    `group flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                      isActive
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`
                  }
                >
                  <Icon
                    className={`mr-3 h-5 w-5 ${
                      location.pathname === link.to
                        ? 'text-primary-600'
                        : 'text-gray-400 group-hover:text-gray-500'
                    }`}
                  />
                  {link.label}
                </NavLink>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;